import {CreateEventPayload, ProcessedMeetingRoomEvent} from '@shared/core';
import {getIanaTimeZone} from '@shared/utilities';

export const createInnerEvent = (start: Date, end: Date): ProcessedMeetingRoomEvent => ({
  id: new Date().getTime().toString(),
  start,
  end,
  isDraggable: true,
});

export interface CreateGoogleEventArgs {
  start: Date;
  end: Date;
  email: string;
  meetingRoomId: string;
  floorAddress: string;
}

export const createGoogleEvent = ({
  start,
  end,
  email,
  meetingRoomId,
  floorAddress,
}: CreateGoogleEventArgs): CreateEventPayload => {
  const timezone = getIanaTimeZone();
  const meetingRoomCalendar = `${meetingRoomId}@resource.calendar.google.com`;
  const location = floorAddress ? {location: floorAddress} : null;

  return {
    summary: 'Meeting room booking',
    ...location,
    description: 'Meeting room booking',
    start: {
      dateTime: start.toISOString(),
      timeZone: timezone,
    },
    end: {
      dateTime: end.toISOString(),
      timeZone: timezone,
    },
    attendees: [{email}, {email: meetingRoomCalendar}],
    calendar_id: meetingRoomCalendar,
  };
};
